import BasicButton from "../../components/BasicButton";
import BasicModal from "../../components/BasicModal";
import useLogin from "./useLogin";
import { useTranslation } from "react-i18next";
import BasicInput from "../../components/BasicInput";
import { stdObject } from "../../data/types/stdObject";

export default function Login({
  isLoading,
  msgType,
  loginPack,
  logoutAction,
}: {
  isLoading: boolean;
  msgType: string;
  loginPack: stdObject;
  logoutAction: () => void;
}) {
  const { t } = useTranslation();
  const {
    loginData,
    updateData,
    handleLogin,
    fields,
    msg,
    msg2,
    msgData,
    closeMsg,
  } = useLogin({
    isLoading,
    msgType,
    loginPack,
    logoutAction,
  });

  return (
    <div className="mainBox">
      <div className="loginBox">
        {fields.map((e, index) => (
          <BasicInput
            key={index}
            type={e === "username" ? "text" : e}
            label={t(`p.${e}`)}
            value={loginData[e as keyof typeof loginData]}
            onChange={(v) => {
              updateData(e, v.target.value);
              return {};
            }}
            onKeyDown={(v) => {
              if (v.keyCode === 13 && index) handleLogin();
              return {};
            }}
          />
        ))}
        <BasicButton
          title={t("p.enter")}
          onClick={handleLogin}
          style={{ marginTop: 10 }}
        />
      </div>
      {msg !== "" && (
        <BasicModal
          open={msg !== ""}
          close={closeMsg}
          data={msg in msgData ? msgData[msg as keyof typeof msgData] : {}}
        />
      )}
      {msg2 !== "" && (
        <BasicModal
          open={msg2 !== ""}
          close={() => closeMsg(2)}
          data={msg2 in msgData ? msgData[msg2 as keyof typeof msgData] : {}}
        />
      )}
    </div>
  );
}
